import {BehaviorSubject, Subject} from "rxjs";
import {MemberSummaryData} from "./member-summary-entity.model";

export class IdentityEvents {

    /**
     * Notifies revocation of a login token
     */
    public static readonly loginRevoked$: Subject<void> = new Subject();

    /**
     * Notifies successful login
     */
    public static readonly loginComplete$: Subject<void> = new Subject();

    /**
     * Notifies the details of the current logged-in member
     */
    public static readonly currentMember$: BehaviorSubject<MemberSummaryData> = new BehaviorSubject(undefined);
}



// WEBPACK FOOTER //
// ./src/app/identity/identity-events.ts